// @ts-check
import classNames from 'classnames';
import React from 'react';
import Card from '../Common/Card';
import LoginFormBusinessBanking, { Head as BoBHead } from '../Common/LoginFormBusinessBanking';
import LoginFormBusinessQ2Banking, { Head as Q2Head } from '../Common/LoginFormBusinessQ2Banking';
import LoginFormPersonalBanking from '../Common/LoginFormPersonalBanking';
import BrRule from './../Common/BrRule';

import './LoginCardMain.scss';

/**
 * @typedef BottomIcon
 * @property {import('~/templates/CSTypes').CSLink} link
 * @property {string} icon_name
 *
 * @typedef LoginCardFormOptions
 * @property {string} usernamePlaceholder
 * @property {string} passwordPlaceholder
 * @property {string} [buttonText='Login']
 * @property {{ link_text: string; link_url: string }[]} links
 * @property {BottomIcon[]} bottom_icons
 *
 * @typedef LoginCardProps
 * @property {import('~/templates/hero/PageHeroLoginForm').PageHeroLoginFormOptionsWith$} options
 */
/** @type {import('~/types/React').ReactFC<LoginCardProps>} */
const LoginCardMain = ({ options }) => (
	<div className="login-card-main">
		<Card className="login-card">
			<h4 className="login-card-header">Online Banking Sign In</h4>
			<div className="row login-switcher-container">
				<a
					className={classNames('login-switcher left personal', options.which === 'personal' ? 'active' : 'not-active')}
					href="/personal"
					{...options?.$?.which}
				>
					<span>Personal</span>
				</a>
				<a
					className={classNames(
						'login-switcher right business',
						options.which === 'business' || options.which === 'business-q2' ? 'active' : 'not-active'
					)}
					href="/business"
					{...options?.$?.which}
				>
					<span>Business</span>
				</a>
			</div>
			<div className="form-container">
				{options.which === 'personal' && <LoginFormPersonalBanking options={options} />}
				{options.which === 'business' && <LoginFormBusinessBanking options={options} />}
				{options.which === 'business-q2' && <LoginFormBusinessQ2Banking options={options} />}
				<BrRule />
				<div className="bottom-icons">
					{options.bottom_icons?.map((bottom_icon, i) => (
						<a className="login-item" href={bottom_icon.link.href} aria-label="Login to Credit Cards" key={i}>
							<i className="login-icon icon" aria-hidden="true" {...bottom_icon.$?.icon_name}>
								{bottom_icon.icon_name}
							</i>
							<div {...bottom_icon.link.$?.title}>
								{bottom_icon.link.title?.split(' ').map((name, i) => (
									<div key={i}>
										{name} <br />
									</div>
								))}
							</div>
						</a>
					))}
				</div>
			</div>
		</Card>
	</div>
);

/** @type {import('~/types/React').ReactFC<import('gatsby').HeadProps>} */
export const Head = (props) => (
	<React.Fragment>
		<Q2Head {...props} />
		<BoBHead {...props} />
	</React.Fragment>
);
export default LoginCardMain;

